module.exports = __webpack_public_path__ + "54b947a07c0522f8413e79f61dbc53b5.svg";